"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ACCOUNT_NUMBER = exports.ACCOUNT_INFO = exports.ACCOUNT_INFO_ERROR = exports.PROFILE_EDIT_MARKETING_SECTION_ID = exports.PROFILE_EDIT_PHONE_SECTION_ID = exports.PROFILE_EDIT_EMAIL_SECTION_ID = exports.PROFILE_VIEW_EMAIL_CHANGED = exports.PROFILE_VIEW_SECTION_ID = exports.PROFILE_UPDATE_ERROR = exports.PROFILE_EDIT_MARKETING_LOADING = exports.PROFILE_EDIT_PHONE_LOADING = exports.PROFILE_EDIT_EMAIL_LOADING = exports.PROFILE_VIEW_LOADING = exports.PROFILE_EDIT_MARKETING_ERROR = exports.PROFILE_EDIT_PHONE_ERROR = exports.PROFILE_EDIT_EMAIL_ERROR = exports.PROFILE_VIEW_ERROR = void 0;
exports.PROFILE_VIEW_ERROR = 'profile-view-error';
exports.PROFILE_EDIT_EMAIL_ERROR = 'profile-edit-email-error';
exports.PROFILE_EDIT_PHONE_ERROR = 'profile-edit-phone-error';
exports.PROFILE_EDIT_MARKETING_ERROR = 'profile-edit-marketing-error';
exports.PROFILE_VIEW_LOADING = 'profile-view-loading';
exports.PROFILE_EDIT_EMAIL_LOADING = 'profile-edit-email-loading';
exports.PROFILE_EDIT_PHONE_LOADING = 'profile-edit-phone-loading';
exports.PROFILE_EDIT_MARKETING_LOADING = 'profile-edit-marketing-loading';
exports.PROFILE_UPDATE_ERROR = 'profile-update-error';
exports.PROFILE_VIEW_SECTION_ID = 'profile-view';
exports.PROFILE_VIEW_EMAIL_CHANGED = 'email-changed';
exports.PROFILE_EDIT_EMAIL_SECTION_ID = 'profile-edit-email';
exports.PROFILE_EDIT_PHONE_SECTION_ID = 'profile-edit-phone';
exports.PROFILE_EDIT_MARKETING_SECTION_ID = 'profile-edit-marketing';
exports.ACCOUNT_INFO_ERROR = 'account-info-error';
exports.ACCOUNT_INFO = 'account-info';
exports.ACCOUNT_NUMBER = 'account-number';
